import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";
import Service from "./service/reducer";
import AlertLog from './alertlog/reducer'

import Team from "./team/reducer";

import Oncalls from "./oncall/reducer";

import Metric from "./metric/reducer";

import Threshold from "./threshold/reducer";

import Organization from "./organization/reducer";

import AlcomScoreDashboard from "./alcomscoredashboard/reducer";

import onCallPolicy from "./onCallPolicy/reducer";

import InviteConfirmation from "./inviteconfirmation/reducer";

import Alert from "./alert/reducer";

import AlertAnalytics from "./alertanalytics/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import ResetPassword from "./auth/resetpassword/reducer";
import Profile from "./auth/profile/reducer";

//tasks
import tasks from "./tasks/reducer";

//Dashboard
import Dashboard from "./dashboard/reducer";
import OpsGenieTeams from "./opsgenie/reducer";
import PagerdutyServices from "./pagerduty/reducer";
import NewRelic from "./newrelic/reducer";
import Datadog from "./datadog/reducer";
import Splunk from "./splunk/reducer"
import EmailConfirmation from "./emailconfirmation/reducer";
import ServiceEmailConfirmation from "./serviceemailconfirmation/reducer";

import AWSResource from "./cloudresource/reducer";

import toastReducer from "./toast/reducers";

import GCPResource from "./gcp/reducer";

import GCPAlerts from "./gcp_alert/reducer";

import GCPThresholds from "./gcp_threshold/reducer";

import AzureResource from "./azure/reducer"

import AzureAlerts from "./azure_alert/reducer";

import AzureThresholds from './azure_threshold/reducer'

import MSTeams from "./msteams/reducer";
import Onboarding from "./onboarding/reducer";

import AppDynamics from "./appDynamics/reducer";
import Dynatrace from "./dynatrace/reducer";
import Daemon from "./daemon/reducer";
import PingMonitor from "./pingmointoring/reducer";

import Rca from "./rca/reducer";
import Incidents from "./statuspage/reducer";
import OCI from "./oci/reducer";
import Sentry from "./sentry/reducer";
import Grafana from "./grafana/reducer";
import Loki from "./loki/reducer";
import Coralogix from "./coralogix/reducer";
import Subscriptions from "./subscriptions/reducer";
import Signoz from "./signoz/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  tasks,
  Dashboard,
  Service,
  Oncalls,
  Metric,
  Threshold,
  Team,
  Organization,
  AlcomScoreDashboard,
  onCallPolicy,
  OpsGenieTeams,
  InviteConfirmation,
  EmailConfirmation,
  ServiceEmailConfirmation,
  PagerdutyServices,
  Alert,
  NewRelic,
  Datadog,
  Splunk,
  AWSResource,
  ResetPassword,
  toastReducer,
  AlertLog,
  GCPResource,
  GCPAlerts,
  GCPThresholds,
  AlertAnalytics,
  AzureResource,
  AzureAlerts,
  AzureThresholds,
  MSTeams,
  Onboarding,
  AppDynamics,
  Grafana,
  Dynatrace,
  PingMonitor,
  Rca,
  Daemon,
  Incidents,
  OCI,
  Sentry,
  Loki,
  Coralogix,
  Subscriptions,
  Signoz
});

export default rootReducer;
